<template>
  <div class="spcore-patient pl-4">
    <SPCoreMenu class="mb-2" />
    Provider List > Provider Profile
    <div class="hvh-flex wrap mt-3">
      <div class="benefit shadow col-12 col-sm-6 mr-4 mb-4">
        <h3 class="no-wrap">Karan Emerick</h3>
        <img class="mt-5" src="test.img" />

        <div class="no-wrap mt-5"><b>Address Line 1:</b> 282 Washington St</div>
        <div class="no-wrap"><b>City :</b> Hartford</div>
        <div class="no-wrap"><b>State :</b> CT</div>

        <div class="no-wrap mt-5"><b>860-545-9560</b></div>

        <div class="no-wrap mt-5"><b>IDN Affiliation </b> CT Childrens Medical Center</div>
        <div class="no-wrap"><b>Specialty :</b> Gastroenterology</div>
      </div>
      <div class="col-12 col-sm-5 mb-4 p-0">
        <div class="shadow">
          <div class="hvh-flex space-between p-3">
            <h3 class="no-wrap">Risk Status</h3>
            <div class="hvh-flex risk px-3">
              <div>High Risk</div>
            </div>
          </div>
          <div class="risk-status p-3">
            <div><span class="yellow-dot" /> Provider has higher than average Pending Patients</div>
            <h3 class="mt-4">Next Best Action</h3>
            <div class="splitter mt-3 pt-3">
              <HvhInputCheckbox><span class="ml-2">Maximum Support</span></HvhInputCheckbox>
              <p class="mt-3 mb-0">Test Data Testt Datta tteeesstt ddatta taest data test data test data test data test data test data</p>
            </div>
          </div>
        </div>
      </div>
      <div class="shadow col-12 col-sm-6 mb-4">
        <h3 class="no-wrap">Patients</h3>
        <div class="hvh-flex wrap">
          <h3 class="no-wrap mr-3">120 Patients</h3>
          <h3 class="no-wrap mr-3">91 Active Patients</h3>
          <h3 class="no-wrap mr-3">29 Pending Patients</h3>
        </div>
        <v-data-table :headers="headers" :items="providerListData" must-sort :pagination.sync="pagination" ref="dt">
          <template slot="items" slot-scope="{ item }">
            <tr>
              <td>
                <spcore-risk :value="item.risk" />
              </td>
              <td>{{ item.riskStatus }}</td>
              <td>{{ item.client }}</td>
            </tr>
          </template>
          <div slot="no-data" :value="true" type="warning">There are no items to show.</div>
        </v-data-table>
      </div>
      <div class="col-12 col-sm-6 mb-4 p-0 pl-sm-4">
        <div class="shadow h-100">
          <SPCoreBarChart class="h-100" title="Product" :data="productBarChartData" nameField="name" valueField="value" background="white" @refresh-data="loadproductData" />
        </div>
      </div>
      <div class="shadow col-12 col-sm-6 mr-4 mb-4 p-3">
        <h3 class="no-wrap mb-4">Input from FRM</h3>
        <div class="provider-inputs mb-3">
          <SPCoreProviderInput class="mb-4" :value="item" v-for="(item, ind) in inputs" :key="ind" @input="$set(inputs, ind, $event)" @delete="inputs.removeAt(ind)" />
        </div>
        <textarea class="spcore-textarea w-100" :value="newInputValue" rows="6" @input="newInputValue = $event.target.value" />
        <div class="hvh-flex end">
          <v-btn flat large class="hvh-btn hvh-btn--primary mr-0 mt-3" :class="{ disabled: isNullOrEmpty(newInputValue) }" @click="postInput">Post</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import axios from '../../axios';
import SPCoreMenu from '../../components/spcore/menu/SPCoreMenu.vue';
import SPCoreBarChart from '../../components/spcore/SPCoreBarChart.vue';
import SPCoreProviderInput from '../../components/spcore/SPCoreProviderInput.vue';
import { isNullOrEmpty } from '../../libraries/common';
export default {
  title: 'Provider Detail',
  components: { SPCoreBarChart, SPCoreMenu, SPCoreProviderInput },
  data() {
    return {
      providerListData: [
        { risk: 'HIGH', riskStatus: 'Cancelled', client: 'Lorem Ipsum' },
        { risk: 'LOW', riskStatus: 'No Restriction', client: 'Lorem Ipsum' },
        { risk: 'MEDIUM', riskStatus: 'Aging Case', client: 'Lorem Ipsum' },
        { risk: 'HIGH', riskStatus: 'Cancelled', client: 'Lorem Ipsum' },
        { risk: 'LOW', riskStatus: 'No Risk', client: 'Lorem Ipsum' },
        { risk: 'MEDIUM', riskStatus: 'Aging Cases', client: 'Lorem Ipsum' },
        { risk: 'HIGH', riskStatus: 'New Patient with high payer restriction', client: 'Lorem Ipsum' },

      ],
      headers: [
        { text: 'RISK', align: 'left', value: 'risk', class: ['text-xs-left hvh-table-header'] },
        { text: 'Risk Status', align: 'left', value: 'riskStatus', class: ['text-xs-left hvh-table-header'] },
        { text: 'Client', align: 'left', value: 'client', class: ['text-xs-left hvh-table-header'] },

      ],
      pagination: { 'sortBy': 'startTime', 'descending': true, 'rowsPerPage': 25 },
      filterListData: {},
      productBarChartData: [],
      cancelRequest: {},
      inputs: [
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      ],
      newInputValue: null,
    }
  },
  methods: {
    loadproductData() {
      if (this.cancelRequest.product)
        this.cancelRequest.product();

      axios.post('/SPCore/providerList/GetProviderList', {
        runId: this.runId,
        ProviderListComponent: "Product",
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.product = c)
      }).then((response) => {
        var translations = {
          pL3: '3PL',
          sDs: 'SDs',
          hcPs: 'HCPs',
          spPs: 'SPPs',
        };

        this.productBarChartData = Object.keys(response.data)
          .map(key => ({
            filterValue: key,
            name: translations[key],
            value: response.data[key],
          }))

      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);

          this.disableIfTimeout(error);
        }
      });
    },
    postInput() {
      // TODO: Add post request for provider inputs
      // axios.post(...)
      this.inputs = [
        ...(this.inputs || []),
        this.newInputValue,
      ];
      this.newInputValue = null;
    },
    isNullOrEmpty,
  }
}
</script>

<style lang="scss" scoped>
.provider-inputs {
  max-height: 300px;
  overflow-y: auto;
  border-bottom: 1px solid black;
}
</style>